import React from "react";
import PropTypes from "prop-types";
import CryptoJS from "crypto-js";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { getCurrentJwt } from "../../util/jwt/decryptToken";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

import Iframe from "react-iframe";
import LoadingOverlay from "react-loading-overlay";
import "assets/scss/styles.css";
import CardBody from "components/Card/CardBody.jsx";
import { PulseLoader } from "react-spinners";
import { css } from "react-emotion";
//import LoadingOverlay from 'react-loading-overlay';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// PowerBi Inport 
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import './powerBiCustom.css'

import Card from "components/Card/Card.jsx";
// POWERBI
import handlePowerBiReport from "../../util/powerBi/handlePowerBiReport";
import { fetchHtmlReportData, fetchHtmlReportingConfig } from "../../util/htmlReporting/htmlReporting";
import { LinearProgress } from "@material-ui/core";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  text-align: center;
  margin-top: 10px;
`;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: true,
      height: "1000px",
      tweetData: [],
      localStorageClientId: "",
    };

    const asyncFunc = async () => {
      // HTML reporting
      let htmlReportingConfig = await fetchHtmlReportingConfig()
      if (htmlReportingConfig) {
        if (htmlReportingConfig.hasOwnProperty('dashboardName')) {
          this.setState(e => { return { ...e, isHtmlReport: true, isLoadingHtmlReport: true } })
          let s3Url = await fetchHtmlReportData(htmlReportingConfig.dashboardName)
          this.setState({
            s3Url: s3Url,
            isLoadingHtmlReport: false,
          })
          return
        }
      }

      // POWERBI - INTEGRATION
      if(localStorage.getItem("powerBiInfo") !== null &&
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("powerBiInfo"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ).report_id !== ''
      ) {
        let powerBiInfo = JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("powerBiInfo"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        );
        handlePowerBiReport(powerBiInfo, getCurrentJwt()).then(data=>{
          try {
            if(data.embed_token[0] !== "") {
              this.setState({
                isActive: true,
                height: "1000px",
                tweetData: [],
                localStorageClientId: "",
                powerBIEmbed: data
              })
            }
          }
          catch(e) {
            console.log(e)
          }
        })
        return
      }
      
      this.setState({ url: "" });
      let aid = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("dappId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
      let shid = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("dsheetId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
      var obj = {
        method: "GET",
        headers: { Authorization: getCurrentJwt() },
      };
      fetch(
        process.env.REACT_APP_QLIK_API +
          "home?cookie=" +
          localStorage.getItem("cookie"),
        obj
      )
        .then((res) => res.json())
        .then(
          (result) => {
            if (result !== false) {
              if (
                this.state.localStorageClientId ===
                "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
              ) {
                this.setState({
                  url:
                    "https://" +
                    process.env.REACT_APP_QLIKURL +
                    "/single/?appid=" +
                    aid +
                    "&sheet=" +
                    shid +
                    // "&opt=nointeraction,noselections&select=clearall&qlikTicket=" +
                    "&qlikTicket=" +
                    localStorage.getItem("ticket") +
                    "&theme=datadelivers4.0",
                });
              } else {
                this.setState({
                  url:
                    "https://" +
                    process.env.REACT_APP_QLIKURL +
                    "/single/?appid=" +
                    aid +
                    "&sheet=" +
                    shid +
                    "&opt=nointeraction,noselections&select=clearall&qlikTicket=" +
                    localStorage.getItem("ticket") +
                    "&theme=datadelivers4.0",
                });
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
    asyncFunc()
  }

  componentDidMount() {
    this.setState({ height: window.innerHeight + "px" });
    this.setState({
      localStorageClientId: JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ),
    });
    setTimeout(
      function() {
        this.setState({
          isActive: false,
        });
        //this.props.history.push("/audiences");
      }.bind(this),
      1000
    );
  }
  state = {
    value: 0,
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };
  handleChangeIndex = (index) => {
    this.setState({ value: index });
  };
  render() {
    var partial;
    const tweetData = this.state.tweetData;
    if (this.state.isActive === true) {
      partial = (
        <center>
          <CardBody />
        </center>
      );
    } else {
      partial = "";
    }
    // Commented the below two lines and assigned a value of 12 to pageSize variable, to remove the Twitter Feed Item from the Dashboard.
    // let pageSize = 9;
    // let innerPageSize = 3;

    let pageSize = 12;

    let clientId = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("clientId"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    );
    // if (clientId == '95a18601-df3c-4cd7-a5f8-b87bd5a52581') {
    //   pageSize = 12
    //   innerPageSize = 0
    // }

    // HTML REPORTING
    if (this.state.isHtmlReport) {
      return (
        <React.Fragment>
          {!this.state.isLoadingHtmlReport? (
            <iframe src={this.state.s3Url} className="powerBiCustom" />
          ): (
            <div className="powerBiCustom" style={{backgroundColor:'#eeeeee'}}>
              <h1 style={{textAlign:'center'}}>Loading report. Please Wait!</h1>
              <LinearProgress color="primary" style={{width:'100%'}}/>
            </div>
          )}
        </React.Fragment>
      )
    }
    
    return (
      <LoadingOverlay
        active={this.state.isActive}
        spinner
        text="Loading Charts..."
      >
        <GridContainer spacing={0}>
        <GridItem xs={pageSize} sm={pageSize} md={pageSize} xl={pageSize}>
              {this.state.powerBIEmbed !== null && this.state.powerBIEmbed !== undefined? (
                <div className="" style={{ padding: "0 50px !important" }}>
                <PowerBIEmbed
                  embedConfig = {{
                    type: 'report',   // Supported types: report, dashboard, tile, visual, qna and paginated report
                    id: this.state.powerBIEmbed.report_id,
                    embedUrl: this.state.powerBIEmbed.embed_url,
                    accessToken: this.state.powerBIEmbed.embed_token,
                    tokenType: models.TokenType.Embed
                  }}
                  cssClassName = { "powerBiCustom" }
                  />
                </div>
              ):(
                <div className="" style={{ padding: "0 50px !important" }}>
                  {partial}
                  <Iframe
                    url={this.state.url}
                    width="100%"
                    height="95vh"
                    id="myId"
                    className="myClassname"
                    display="initial"
                    position="relative"
                    allowFullScreen
                  />
                </div>
              )}
          </GridItem>
        </GridContainer>
      </LoadingOverlay>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(dashboardStyle)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx